import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jiraBusinessCapacityEmbedRoute } from '@atlassian/jira-router-routes-business-capacity-routes/src/jiraBusinessCapacityEmbedRoute.tsx';
import { businessCapacityEntryPoint } from '@atlassian/jira-spa-apps-business-capacity/entrypoint.tsx';

export const jiraBusinessCapacityEmbedRouteEntry = createEntry(
	jiraBusinessCapacityEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.jwm-capacity-embed',

		entryPoint: () => businessCapacityEntryPoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-capacity-entries/src/jiraBusinessCapacityEmbedRouteEntry.tsx',
				whichExportToUse: 'jiraBusinessCapacityEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
